(() => {
  // app/scripts/common/function/pagination.js
  window.addEventListener("DOMContentLoaded", (event) => {
    let load_more = document.querySelector(".gird-load");
    let product_container = document.querySelector(".product-load-more .row");
    load_more.addEventListener("click", (e) => {
      e.preventDefault();
      var _next_url = e.target.dataset.href;
      console.log(_next_url);
      fetch(_next_url).then((e2) => e2.text()).then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        let new_products = div.querySelectorAll(".product-slider-content .row .product-container");
        new_products.forEach((ele) => {
          product_container.appendChild(ele);
        });
        let new_loadmore = div.querySelector(".gird-load");
        if (new_loadmore) {
          load_more.dataset.href = new_loadmore.dataset.href;
          load_more.style.order = "1";
        } else {
          load_more.remove();
        }
      });
    });
  });
})();
